export const blogCategories = ['Aile', 'İlişkiler', 'Çocuk & Ergen', 'Psikoloji'];

export const blogArticles = [
  {
    id: 1,
    title: 'Sağlıklı Bir İlişkinin 7 Temel Taşı',
    category: 'İlişkiler',
    preview: 'Sağlıklı ilişkiler kendiliğinden oluşmaz. Bilinçli bir çaba, empati ve doğru iletişim gerektirir. Bu yazıda güçlü bir ilişkinin temellerini keşfediyoruz.',
    image: 'https://readdy.ai/api/search-image?query=couple%20sitting%20together%20warmly%20on%20couch%20in%20modern%20minimal%20living%20room%20soft%20natural%20light%20warm%20tones%20intimate%20and%20loving%20atmosphere%20editorial%20photography&width=600&height=400&seq=blog001&orientation=landscape',
    date: '15 Mart 2026',
    readTime: '5 dk',
  },
  {
    id: 2,
    title: 'Aile İçi Çatışmaları Çözmenin Etkili Yolları',
    category: 'Aile',
    preview: 'Her ailede zaman zaman anlaşmazlıklar yaşanır. Önemli olan bu çatışmaları nasıl ele aldığınız. Uzlaşmacı iletişim teknikleri ile huzurlu bir aile ortamı mümkün.',
    image: 'https://readdy.ai/api/search-image?query=happy%20family%20together%20in%20bright%20warm%20living%20room%20parents%20and%20children%20smiling%20natural%20light%20cozy%20home%20atmosphere%20editorial%20photography&width=600&height=400&seq=blog002&orientation=landscape',
    date: '8 Mart 2026',
    readTime: '6 dk',
  },
  {
    id: 3,
    title: 'Ergenlik Döneminde Ebeveyn Olmak',
    category: 'Çocuk & Ergen',
    preview: 'Ergenlik, hem çocuk hem de ebeveyn için zorlayıcı bir dönemdir. Sınır koyarken sevgiyi korumak mümkün; sadece doğru araçlara ihtiyacınız var.',
    image: 'https://readdy.ai/api/search-image?query=mother%20and%20teenage%20daughter%20having%20warm%20conversation%20in%20minimal%20modern%20room%20soft%20beige%20tones%20natural%20light%20editorial%20photography&width=600&height=400&seq=blog003&orientation=landscape',
    date: '1 Mart 2026',
    readTime: '7 dk',
  },
  {
    id: 4,
    title: 'Kaygı ile Başa Çıkmanın Psikolojik Yolları',
    category: 'Psikoloji',
    preview: 'Modern hayatın koşuşturmacasında kaygı çok yaygın bir deneyim. Ancak doğru tekniklerle kaygıyı yönetmek ve yaşam kalitenizi yükseltmek mümkün.',
    image: 'https://readdy.ai/api/search-image?query=person%20meditating%20peacefully%20in%20minimal%20bright%20room%20natural%20light%20plants%20calm%20atmosphere%20mindfulness%20wellness%20editorial%20photography&width=600&height=400&seq=blog004&orientation=landscape',
    date: '22 Şubat 2026',
    readTime: '5 dk',
  },
  {
    id: 5,
    title: 'Evlilik Krizlerini Fırsata Dönüştürmek',
    category: 'İlişkiler',
    preview: 'Krizler sona mı işaret eder? Mutlaka değil. Doğru yaklaşımla bir evlilik krizi, çiftin birbirini yeniden keşfetmesinin ve ilişkiyi güçlendirmesinin başlangıcı olabilir.',
    image: 'https://readdy.ai/api/search-image?query=couple%20walking%20together%20in%20sunlit%20park%20holding%20hands%20warm%20golden%20light%20from%20behind%20minimal%20romantic%20atmosphere%20editorial%20photography&width=600&height=400&seq=blog005&orientation=landscape',
    date: '14 Şubat 2026',
    readTime: '8 dk',
  },
  {
    id: 6,
    title: 'Çocuklarda Duygusal Zeka Nasıl Geliştirilir?',
    category: 'Çocuk & Ergen',
    preview: 'Duygusal zeka, akademik başarıdan çok daha belirleyici bir yaşam becerisidir. Çocuğunuzun duygusal dünyasını anlamak ve geliştirmek için ne yapabilirsiniz?',
    image: 'https://readdy.ai/api/search-image?query=parent%20and%20young%20child%20playing%20together%20on%20floor%20minimal%20bright%20room%20warm%20natural%20light%20joyful%20connection%20bonding%20editorial%20photography&width=600&height=400&seq=blog006&orientation=landscape',
    date: '5 Şubat 2026',
    readTime: '6 dk',
  },
];